import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Sell from "@/pages/Sell";
import Chat from "@/pages/Chat";
import Profile from "@/pages/Profile";
import Checkout from "@/pages/Checkout";
import Admin from "@/pages/Admin";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
    <div className="w-10 h-10 rounded-full border-4 border-[#DBEAFE] border-t-[#0B4DA2] animate-spin" />
  </div>
);

const Protected = ({ children }) => {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <Loader />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
};

function AppRoutes() {
  const { ready } = useAuth();
  if (!ready) return <Loader />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/user/:id" element={<Profile />} />
        <Route path="/sell" element={<Protected><Sell /></Protected>} />
        <Route path="/chat" element={<Protected><Chat /></Protected>} />
        <Route path="/chat/:id" element={<Protected><Chat /></Protected>} />
        <Route path="/checkout/:productId" element={<Protected><Checkout /></Protected>} />
        <Route path="/profile" element={<Protected><Profile /></Protected>} />
        <Route path="/admin" element={<Protected><Admin /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;

